import React from 'react';
import { AccessManagementPage } from 'src/components/access-management/AccessManagementPage';

export const AccessManagement: React.FC = () => <AccessManagementPage />;
